import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { COMPANY } from '../data/seedData';

export default function TakPage() {
  return (
    <>
      <SeoHead
        title="Tak - RB Glasfiber A/S"
        description="Tak for din henvendelse til RB Glasfiber A/S. Vi vender tilbage hurtigst muligt."
        canonical="https://www.rb-glasfiber.dk/tak"
      />

      <section className="pt-36 pb-20 min-h-[70vh] flex items-center justify-center bg-slate-50">
        <div className="max-w-2xl mx-auto px-4 text-center space-y-6">
          <div className="w-16 h-16 rounded-full bg-[#1e9457] text-white flex items-center justify-center mx-auto text-2xl shadow-lg">
            <i className="fa-solid fa-check"></i>
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 uppercase tracking-tight">
            Tak for din henvendelse!
          </h1>

          <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
            Vi sætter stor pris på, at du har taget dig tid til at kontakte os. Din besked er blevet sendt, og vores team vil hurtigst muligt gennemgå din henvendelse.
          </p>

          <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm text-left space-y-4 max-w-lg mx-auto">
            <h3 className="font-bold text-slate-900 text-sm uppercase tracking-wider text-[#1e9457]">
              Hvad kan du forvente nu?
            </h3>
            <ul className="text-sm text-slate-700 space-y-2">
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-clock text-[#1e9457] mt-1"></i>
                <span><strong>Svar fra os:</strong> Vi bestræber os på at besvare alle henvendelser inden for 24 timer.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-solid fa-circle-info text-[#1e9457] mt-1"></i>
                <span><strong>Yderligere information:</strong> Hvis din henvendelse kræver det, kontakter vi dig for at få flere detaljer.</span>
              </li>
            </ul>

            <div className="pt-4 border-t border-slate-100 text-xs text-slate-500">
              Har du brug for øjeblikkelig assistance? Ring direkte til os på{' '}
              <a href={`tel:${COMPANY.phoneRaw}`} className="font-bold text-slate-900 underline whitespace-nowrap">
                {COMPANY.phone}
              </a>
              .
            </div>
          </div>

          <div className="pt-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-slate-900 hover:bg-slate-800 text-white font-bold uppercase tracking-wider text-xs transition-colors shadow"
            >
              <i className="fa-solid fa-arrow-left text-xs"></i>
              <span>Tilbage til forsiden</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
